import { render } from "./DetailSettings.vue?vue&type=template&id=2b9583a2&scoped=true"
import script from "./DetailSettings.vue?vue&type=script&lang=js"
export * from "./DetailSettings.vue?vue&type=script&lang=js"

import "./DetailSettings.vue?vue&type=style&index=0&id=2b9583a2&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9583a2"]])

export default __exports__